/**
 * Store Vuex 状态管理
 *
 * @Document: https://vuex.vuejs.org/zh/
 **/
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js